import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomToast from "./CustomToast";
import "./TopDeals.css";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

function TopDeals() {
  const [topDeals, setTopDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Success toast notification
  const handleCartSuccess = (message) => {
    toast(<CustomToast message={`1 product`} />, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
    });
  };

  // Error toast notification
  const handleCartError = (message) => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  useEffect(() => {
    async function fetchTopDeals() {
      try {
        const response = await fetch(
          `${API_BASE_URL}/product/mis_products/?page_size=5&mis_type=top_deals`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch top deals");
        }
        const data = await response.json();

        // Transform API data to match the ProductCard component format
        const formattedDeals = data.map((product) => ({
          id: product.id,
          name: product.name,
          image: product.picture, // Correcting Image URL
          tagline: product.label.length > 0 ? product.label[0].name : "",
          currentPrice: parseFloat(product.actual_unit_price),
          originalPrice: parseFloat(product.unit_price),
          discount: product.discount,
          labels: product.tags.map((tag) => tag.name),
        }));

        setTopDeals(formattedDeals);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    }

    fetchTopDeals();
  }, []);

  return (
    <section className="top-deals">
      <ToastContainer />
      <h3 className="text-center mb-4">Top Deals</h3>
      <div className="container-fluid">
        {loading ? (
          <p className="loading-text">Loading top deals...</p>
        ) : error ? (
          <p className="error-text">{error}</p>
        ) : (
          <div className="row justify-content-center align-item-center ms-0 me-0 gy-3 gx-4">
            {topDeals.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onCartError={handleCartError}
                onCartSuccess={handleCartSuccess}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default TopDeals;
